import React from "react";
import showIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-show-table.svg";
import hideIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-hide-table.svg";

export const ShowHideTable = ({ showTable, setShowTable }) => {
  return (
    <img
      src={showTable ? hideIcon : showIcon}
      alt={showTable ? "Hide Icon" : "Show Icon"}
      width={25}
      height={25}
      onClick={() => setShowTable(!showTable)}
      className="show-hide-table-icon"
    />
  );
};
